import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetRegionListSucceed, EGetRegionListActionType } from './types';
import { IRegionList } from '../../../types/regionList';

export const getRegionListSucceed: (data: IRegionList) => TGetRegionListSucceed = actionGenerator<
  EGetRegionListActionType.Succeed,
  IRegionList
>(EGetRegionListActionType.Succeed);
